module.exports = __webpack_public_path__ + "media/flags/rw-69f73bb9.svg";